
import React, { useState, useRef, useEffect } from 'react';
import { getData, postData } from '../../../../ApiServices/ApiService';
import { ORG_GET_SERVICE_LIST_SEARCH, ORG_CLIENT_SEARCH_TO_ADD_GROUPMEMBER, ORG_GET_EMPLOYEE_LIST, 
  ORG_GET_RECEIPT_LIST, ORG_PRINT_RECEIPT } from '../../../../ApiServices/BaseURL';
import { useLocation } from 'react-router-dom';
import { useTheme } from '../../../../GlobalContext/GlobalContext';
import { logFrontendException } from '../../../../Utils/Exception';

const InvoiceReceiptController = (receiptList, onRefresh,hasMoreServerDataReceipt,offsetReceipt,isFilterDataReceipt,setIsFilterDataReceipt) => {
  const { setIsLoginPopup } = useTheme();
  const location = useLocation();

  const [filterError, setFilterError] = useState('');
  const [showFilters, setShowFilters] = useState(false);
  const [filterListLoading, setFilterListLoading] = useState(false);
  const [filterListError, setFilterListError] = useState('');
  const [clientList, setClientList] = useState([]);
  const [searchUser, setSearchUser] = useState(() => { return location?.state?.selectedTab === 3 ? location?.state?.clientName || '' : '' });
  const [searchLoading, setSearchLoading] = useState(false);
  const [searchError, setSearchError] = useState('');
  const [serviceOptions, setServiceOptions] = useState([]);
  const [servicesLoading, setServicesLoading] = useState(false);
  const [servicesError, setServicesError] = useState('');
  const [userLoading, setUserLoading] = useState(false);
  const [userError, setUserError] = useState('');
  const [userOptions, setUserOptions] = useState([]);
  const [receiptInfoList, setReceiptInfoList] = useState([]);
  const [printReceiptLoading, setPrintReceiptLoading] = useState(false);
  const [currentDocIndex, setCurrentDocIndex] = useState(null);
  const [printReceiptError, setPrintReceiptError] = useState({});

  const pageName = "ServiceEstimateController";
  const storedUserId = JSON.parse(localStorage.getItem("_userInfo_"))?.emp_id;

  useEffect(() => {
    setReceiptInfoList(receiptList);
  }, [receiptList]);

  useEffect(() => {
    fetchServices();
    fetchUserList();
  }, [])

  const ItemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(receiptInfoList?.length / ItemsPerPage);

  // Function to handle page change
  const handlePageChange = (pageNumber) => {
    if (pageNumber > totalPages && hasMoreServerDataReceipt) {
        // We reached end of loaded data, try to fetch more
        if(!isFilterDataReceipt){
        onRefresh(offsetReceipt);
        }
      }
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  // Calculate the index of the first and last items on the current page
  const indexOfLastItem = currentPage * ItemsPerPage;
  const indexOfFirstItem = indexOfLastItem - ItemsPerPage;

  // Slice the data for the current page
  const currentTasks = receiptInfoList.slice(indexOfFirstItem, indexOfLastItem);

  const maxVisiblePages = 3;

  const getVisiblePages = () => {
    const startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    const endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    // Adjust startPage if we're near the end
    const adjustedStartPage = Math.max(1, endPage - maxVisiblePages + 1);

    return Array.from({ length: endPage - adjustedStartPage + 1 }, (_, index) => adjustedStartPage + index);
  };

  const visiblePages = getVisiblePages();

  const [filterData, setFilterData] = useState({
    clientName: null,
    services: null,
    generatedDate: "",
    generatedBy: null
  });

  useEffect(() => {
    if (location?.state?.selectedTab === 3 && location?.state?.clientName && location?.state?.clientId) {
      setFilterData((prevData) => ({
        ...prevData,
        clientName: {
          client_name: location?.state?.clientName,
          client_id: location?.state?.clientId,
        },
      }));
    }
  }, [location?.state?.selectedTab]);

  const handleFilterChange = (field, value) => {
    setFilterData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };

  const toggleFilters = () => {
    setShowFilters((prev) => !prev); // Toggle the filter visibility
  };

  const applyFilters = () => {
    fetchReceiptFilterList();
  }

  const resetFilters = () => {
    if (filterData?.clientName || filterData?.services || filterData?.generatedDate || filterData?.generatedBy) {
      onRefresh();
      setCurrentPage(1);
    }
    setFilterError('');
    setFilterData({
      clientName: null,
      services: null,
      generatedDate: "",
      generatedBy: null,
    });
    setClientList([]);
    setSearchUser('');
    setSearchError('');
    setFilterListError('');
  }

  const cancelFilters = () => {
    resetFilters();
    setShowFilters(!showFilters);
  }

  const handleSearchInputText = (value) => {
    setSearchUser(value);
    setSearchError('');
    setClientList([]);
    if (!value) {
      setFilterData((prevData) => ({
        ...prevData,
        clientName: null,
      }));
    }
  };

  const handleSelectClient = (client) => {
    handleFilterChange('clientName', client);
    setSearchUser(client?.client_name);
    setClientList([]);
  };

  const handleSearchClient = async () => {
    try {
      setSearchError('');
      setSearchLoading(true);
      setClientList([]);
      if (!searchUser) {
        setSearchError('Please enter valid text'); return;
      }
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
      const payLoad = { emp_id_auth: storedUserInfo?.emp_id, search_type: "GENERIC", search_word: searchUser }

      //console.log('team Data', payLoad);
      // Make the API call
      const response = await postData(ORG_CLIENT_SEARCH_TO_ADD_GROUPMEMBER, payLoad);
      const responseData = await response.json();
      //console.log('response Data', responseData);

      // Check for success (200) and internal status code
      if (response?.status === 200) {
        if (responseData?.statusCode === 200) {
          if (responseData?.message.toLowerCase() === 'success') {
            setClientList(responseData?.dataJ || []);
          } else {
            setSearchError(responseData?.info || 'Failed to fetch client. Please try again.');
            logFrontendException(storedUserId, pageName, "handleSearchClient", responseData?.info || '');
          }
        } else {
          setSearchError(responseData?.info || 'Failed to fetch client. Status code error.');
          logFrontendException(storedUserId, pageName, "handleSearchClient", responseData?.info || '');
        }
      }
      // Token-related errors: 400, 401, 403
      else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
          setSearchError('Unauthorized access. Your session may have expired. Please log in again.');
          logFrontendException(storedUserId, pageName, "handleSearchClient", response || '');
          // Optionally, redirect to the login page or refresh the token
          // Example: redirectToLogin();
        } else {
          setSearchError(responseData?.info || 'Bad request. Please check the request parameters.');
          logFrontendException(storedUserId, pageName, "handleSearchClient", response || '');
        }
      }
     
      // Unexpected or network-related errors
      else {
        setSearchError('Unexpected error occurred. Please try again later.');
        logFrontendException(storedUserId, pageName, "handleSearchClient", response || '');
      }
    } catch (error) {
     
        setSearchError(`Failed to fetch client. Please check your network connection and try again.`);
        logFrontendException(storedUserId, pageName, "handleSearchClient-catch", error || '');
      
    } finally {
      setSearchLoading(false);
    }
  };

  const fetchReceiptFilterList = async () => {
    try {
      setFilterError('');
      setFilterListError('');
      if (!(filterData?.clientName || filterData?.services || filterData?.generatedDate || filterData?.generatedBy)) {
        setFilterError('Please enter/select any one of the above');
        return;
      }
      setFilterListLoading(true);
      setFilterListError('');

      setReceiptInfoList([]);
      setCurrentPage(1);
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
      const payLoad = {
        "emp_id_auth": storedUserInfo?.emp_id,
        "client_id": filterData?.clientName?.client_id,
        "service_id": filterData?.services?.value,
        "receipt_date": filterData?.generatedDate,
        "receipt_gen_emp_id": filterData?.generatedBy?.value,
        "query_type": "filter",
      }

      console.log('---receipt filter:---', payLoad);

      const response = await postData(ORG_GET_RECEIPT_LIST, payLoad);
      const responseData = await response.json();

      if (response?.status === 200) {
        if (responseData?.statusCode === 200) {
          if (responseData?.message.toLowerCase() === 'success') {
            if (responseData?.dataJ?.length > 0) {
              setReceiptInfoList(responseData?.dataJ);
              setIsFilterDataReceipt(true);
            } else {
              setFilterListError(responseData?.info || 'No receipt list available');
              logFrontendException(storedUserId, pageName, "fetchReceiptFilterList", responseData?.info || '');
            }
          } else {
            setFilterListError(responseData?.info || 'Failed to fetch receipt list. Please try again.');
            logFrontendException(storedUserId, pageName, "fetchReceiptFilterList", responseData?.info || '');
          }
        } else {
          setFilterListError(responseData?.info || 'Failed to fetch receipt list. Status code error.');
          logFrontendException(storedUserId, pageName, "fetchReceiptFilterList", responseData?.info || '');
        }
      }
      else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
          setFilterListError('Unauthorized access. Your session may have expired. Please log in again.');
          logFrontendException(storedUserId, pageName, "fetchReceiptFilterList", response || '');
        } else {
          setFilterListError(responseData?.info || 'Bad request. Please check the request parameters.');
          logFrontendException(storedUserId, pageName, "fetchReceiptFilterList", response || '');
        }
      }
      
      else {
        setFilterListError('Unexpected error occurred. Please try again later.');
        logFrontendException(storedUserId, pageName, "fetchReceiptFilterList", response || '');
      }
    } catch (error) {
     
        setFilterListError(`Failed to fetch receipt list. Please check your network connection and try again.`);
        logFrontendException(storedUserId, pageName, "fetchReceiptFilterList-catch", error || '');
      
    } finally {
      setFilterListLoading(false);
    }
  }

  const fetchServices = async () => {
    setServicesLoading(true);
    setServiceOptions([]);
    setServicesError('');
    try {
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_')); // Get user info from localStorage
      const payload = {
        emp_id_auth: storedUserInfo?.emp_id,
      };

      // API call to fetch GST services
      const response = await postData(ORG_GET_SERVICE_LIST_SEARCH, payload);
      const responseData = await response.json();

      if (response?.status === 200) {
        if (responseData?.statusCode === 200) {
          if (responseData?.message?.toLowerCase() === "success") {
            const services = responseData?.dataJ.map((service) => ({
              label: service.service_name,
              value: service.service_id,
            }));
            setServiceOptions(services);
          } else {
            setServicesError(responseData?.info || 'Service search failed.');
            logFrontendException(storedUserId, pageName, "fetchServices", responseData?.info || '');
          }
        } else {
          setServicesError(responseData?.info || 'Unexpected response code from the server.');
          logFrontendException(storedUserId, pageName, "fetchServices", responseData?.info || '');
        }
      }
      else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
          setServicesError('Unauthorized access. Your session may have expired. Please log in again.');
          logFrontendException(storedUserId, pageName, "fetchServices", response || '');
          // Optionally, redirect to the login page or refresh the token
          // Example: redirectToLogin();
        } else {
          setServicesError(responseData?.info || 'Bad request. Please check the request parameters.');
          logFrontendException(storedUserId, pageName, "fetchServices", response || '');
        }
      }
      // Internal Server Error: 500
      
      // Unexpected or network-related errors
      else {
        setServicesError('Unexpected error occurred. Please try again later.');
        logFrontendException(storedUserId, pageName, "fetchServices", response || '');
      }
    } catch (error) {
      // Handle various error scenarios
     
        // An error occurred in setting up the request
        setServicesError(`Failed to search service options. Please check your network connection and try again.`);
        logFrontendException(storedUserId, pageName, "fetchServices-catch", error || '');
      
    } finally {
      setServicesLoading(false);
    }
  };
  const fetchUserList = async () => {
    try {
      setUserLoading(true);
      setUserError('');

      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

      // Make the API call
      const response = await getData(`${ORG_GET_EMPLOYEE_LIST}?emp_id_auth=${storedUserInfo?.emp_id}`);
      const responseData = await response.json();

      // Check for success (200) and internal status code
      if (response?.status === 200) {
        if (responseData?.statusCode === 200) {
          if (responseData?.message.toLowerCase() === 'success') {
            if (responseData?.dataJ?.length > 0) {
              const formattedTeams = responseData.dataJ.map(service => ({
                label: service.emp_name,
                value: service.emp_id
              }));
              setUserOptions(formattedTeams);
            } else {
              setUserError(responseData?.info || 'Data Not Found');
              logFrontendException(storedUserId, pageName, "fetchUsersList", responseData?.info || '');
            }
          } else {
            setUserError(responseData?.info || 'Failed to fetch User data. Please try again.');
            logFrontendException(storedUserId, pageName, "fetchUsersList", responseData?.info || '');
          }
        } else {
          setUserError(responseData?.info || 'Failed to fetch User data. Status code error.');
          logFrontendException(storedUserId, pageName, "fetchUsersList", responseData?.info || '');
        }
      }
      // Token-related errors: 400, 401, 403
      else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
          setUserError('Unauthorized access. Your session may have expired. Please log in again.');
          logFrontendException(storedUserId, pageName, "fetchUsersList", response || '');
          // Optionally, redirect to the login page or refresh the token
          // Example: redirectToLogin();
        } else {
          setUserError(responseData?.info || 'Bad request. Please check the request parameters.');
          logFrontendException(storedUserId, pageName, "fetchUsersList", response || '');
        }
        setIsLoginPopup(true)
      }
      
      // Unexpected or network-related errors
      else {
        setUserError('Unexpected error occurred. Please try again later.');
        logFrontendException(storedUserId, pageName, "fetchUsersList", response || '');
      }
    } catch (error) {
      
        setUserError(`Failed to fetch User data. Please check your network connection and try again.`);
        logFrontendException(storedUserId, pageName, "fetchUsersList-catch", error || '');
      
    } finally {
      setUserLoading(false);
    }
  }

  const printReceiptDocument = async (receiptId) => {
    try {
      setPrintReceiptLoading((prev) => ({ ...prev, [receiptId]: true }));
      setPrintReceiptError({});
      setPrintReceiptError((prev) => ({ ...prev, [receiptId]: '' }));
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

      // Make the API call
      const response = await getData(`${ORG_PRINT_RECEIPT}?emp_id_auth=${storedUserInfo?.emp_id}&receipt_id=${receiptId}`);
      const responseData = await response.json();

      // Check for success (200) and internal status code
      if (response?.status === 200) {
        if (responseData?.statusCode === 200) {
          if (responseData?.message.toLowerCase() === 'success') {
            if (responseData?.dataJ?.length > 0) {
              const downloadUrl = responseData?.dataJ?.[0]?.download_url;
              if (downloadUrl) {
                try {
                  // Fetch the file as a blob
                  const fileResponse = await fetch(downloadUrl);
                  const blob = await fileResponse.blob();

                  const url = URL.createObjectURL(new Blob([blob], { type: "application/pdf" }));

                  let iframe = document.createElement("iframe");
                  iframe.style.position = "absolute";
                  iframe.style.width = "0px";
                  iframe.style.height = "0px";
                  iframe.style.border = "none";
                  document.body.appendChild(iframe);

                  // Load the PDF into the iframe and trigger print
                  iframe.src = url;
                  iframe.onload = () => {
                    iframe.contentWindow.focus();
                    iframe.contentWindow.print();
                  };

                } catch (error) {
                  console.error('Error downloading file:', error);
                  setPrintReceiptError((prev) => ({ ...prev, [receiptId]: 'An error occurred while attempting to download the file. Please try again.' }));
                }
              } else {
                setPrintReceiptError((prev) => ({ ...prev, [receiptId]: 'Download URL not available.' }));
              }
            } else {
              setPrintReceiptError((prev) => ({ ...prev, [receiptId]: responseData?.info || 'No receipt available to print.' }));
            }
          } else {
            console.log(responseData?.info || 'Failed to fetch receipt document. Please try again.');
            setPrintReceiptError((prev) => ({ ...prev, [receiptId]: responseData?.info || 'Failed to fetch receipt. Please try again.' }));
          }
        } else {
          setPrintReceiptError((prev) => ({ ...prev, [receiptId]: responseData?.info || 'Failed to fetch receipt. Status code error.' }));
        }
      }
      // Token-related errors: 400, 401, 403
      else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
          setPrintReceiptError((prev) => ({ ...prev, [receiptId]: 'Unauthorized access. Your session may have expired. Please log in again.' }));
          // Optionally, redirect to the login page or refresh the token
          // Example: redirectToLogin();
        } else {
          setPrintReceiptError((prev) => ({ ...prev, [receiptId]: responseData?.info || 'Bad request. Please check the request parameters.' }));
        }
      }
      else {
        setPrintReceiptError((prev) => ({ ...prev, [receiptId]: 'Unexpected error occurred. Please try again later.' }));
      }
    } catch (error) {
      // Handle various error scenarios
      if (error.response) {
        // Server responded with a status outside the 2xx range
        setPrintReceiptError((prev) => ({ ...prev, [receiptId]: `Error: ${error.response.status}. ${error.response.data?.message || 'Failed to fetch receipt. Please try again.'}` }));
      } else if (error.request) {
        // Request was made but no response was received
        setPrintReceiptError((prev) => ({ ...prev, [receiptId]: 'No response received from the server. Please check your network connection and try again.' }));
      } else {
        // An error occurred in setting up the request
        setPrintReceiptError((prev) => ({ ...prev, [receiptId]: `Failed to fetch receipt. Please check your network connection and try again.` }));
      }
    } finally {
      setPrintReceiptLoading((prev) => ({ ...prev, [receiptId]: false }));
    }
  }

  return {
    handlePageChange,
    currentTasks,
    totalPages,
    currentPage, visiblePages,
    filterData,
    setFilterData,
    handleFilterChange,
    applyFilters, cancelFilters, resetFilters, toggleFilters,
    filterError, showFilters, filterListLoading, filterListError,
    searchUser, searchLoading, searchError, clientList,
    serviceOptions, servicesLoading, servicesError,
    userOptions, userLoading, userError,
    handleSearchInputText, handleSearchClient, handleSelectClient,
    printReceiptDocument, printReceiptLoading, printReceiptError

  }
}

export default InvoiceReceiptController